<script setup>
import ChangeLogTable from '@/components/Dashboard/ChangeLogs/ChangeLogTable.vue';

const props = defineProps({
  changeLogs: {
    type: Object,
    required: true,
  },
  filters: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<template>
  <div>
    <div class="tile my-4 px-3 py-4">
      <flow-group :flow-group="flowGroup" />
    </div>
    <div class="tile my-4">
      <change-log-table :change-logs="changeLogs" :filters="filters" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DashboardLayout from '@/Layouts/DashboardLayout';
import IntegrationFlowLayout from '@/Layouts/IntegrationFlowLayout';
import FlowGroup from '@/components/Dashboard/FlowGroup';

export default {
  name: 'FlowChangeLog',

  layout: [DashboardLayout, IntegrationFlowLayout],

  components: {
    FlowGroup,
  },

  computed: {
    ...mapGetters('flowsDetails', ['flowGroup']),
  },
};
</script>
